// @ts-nocheck

import React, { useEffect, useState } from "react";
import SoftBox from "../../../components/common/softBox";
import SoftTypography from "../../../components/common/softTypography";
import SoftInput from "../../../components/common/softInput";
import SoftButton from "../../../components/common/softButton";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {
  editOtherService,
  getOtherServiceById,
} from "../../../features/otherServices";
import DashboardNavbar from "../../../components/navbars/dashboardNavbar";
import { FormControl, MenuItem, Select } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
const EditOtherService = () => {
  const { id } = useParams<{ id: string }>();
  const { otherService, status } = useSelector(
    (state: any) => state.otherService
  );
  const [language, setLanguage] = useState("en");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    title: "", // Room service name
    key: "", // Description for the room service (string format)
    icon: null, // Image for the room service
    order_type: "",
  });

  useEffect(() => {
    // Fetch room service data by ID
    setFormData({
      title: "", // Room service name
      key: "", // Description for the room service (string format)
      icon: null, // Image for the room service
      order_type: "",
      is_visible: false,
    });
    dispatch(getOtherServiceById({ id, lan: language }));
  }, [dispatch, id, language]);

  useEffect(() => {
    if (status && otherService) {
      const data = otherService.data;
      setFormData({
        title: data.title,
        key: data.key,
        icon: data.icon,
        order_type: data.order_type,
        is_visible: data.is_visible,
      });
    }
  }, [status, otherService]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value, // Handle checkbox correctly
    }));
  };

  const handleThumbnailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFormData((prev) => ({
        ...prev,
        icon: e.target.files[0], // Handle photo image change
      }));
    }
  };

  const handleSubmit = () => {
    if (!formData.title.trim()) {
      toast.error("Title is required.");
      return;
    }

    const formDataFinal = new FormData();

    Object.entries(formData).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        formDataFinal.append(key, value); // Append name, description, photo
      }
    });

    dispatch(
      editOtherService({
        id,
        updatedOtherService: formDataFinal,
        lan: language,
      })
    )
      .then((resultAction) => {
        if (editOtherService.rejected.match(resultAction)) {
          console.error(resultAction.payload || resultAction.error);
        } else {
          toast.success("Other Service updated successfully!");
          navigate("/other-services");
        }
      })
      .catch((err: any) => {
        console.error(err, "error");
        toast.error("An error occurred while updating the room service.");
      });
  };

  return (
    <SoftBox className="language-box">
      <DashboardNavbar />
      <SoftBox>
        <SoftBox mb={2}>
          <SoftTypography variant="h4" fontWeight="bold" textAlign="left">
            Edit Other Service
          </SoftTypography>
        </SoftBox>

        <SoftBox component="form" role="form">
          {/* Name Input */}
          <SoftBox mb={2}>
            <FormControl fullWidth size="small">
              <SoftTypography
                htmlFor="language"
                style={{
                  fontSize: "15px ",
                  fontWeight: "500",
                  lineHeight: "normal",
                  marginBottom: "10px",
                }}
              >
                Language
              </SoftTypography>
              <Select
                id="language"
                name="language"
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
                IconComponent={KeyboardArrowDownIcon}
                    fullWidth
                    size="small"
                    sx={{
                      padding: "0px 8px !important",
                      height: "40px !important",
                      display: "block !important",
                      ".MuiSelect-select": {
                        padding: "0px 8px !important",
                        height: "40px !important",
                      },
                      ".MuiSelect-nativeInput": {
                        height: "40px !important",
                      },
                      ".css-1e270hg-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                      ".css-8kuacp-MuiSvgIcon-root-MuiSelect-icon": {
                        display: "block !important",
                        fontSize: "1.25rem !important",
                      },
                    }}
              >
                <MenuItem style={{ marginBottom: "5px" }} value="en">
                  English
                </MenuItem>
                <MenuItem value="ar">Arabic</MenuItem>
              </Select>
            </FormControl>
          </SoftBox>
          <SoftBox mb={2}>
            <SoftBox mb={1} ml={0.5}>
              <SoftTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Title
              </SoftTypography>
            </SoftBox>
            <SoftInput
              type="text"
              name="title"
              placeholder="Enter the title"
              value={formData.title}
              onChange={handleChange}
            />
          </SoftBox>

          {language === "en" && (
            <>
              <SoftBox mb={2}>
                <SoftBox mb={1} ml={0.5}>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Key
                  </SoftTypography>
                </SoftBox>
                <SoftInput
                  type="text"
                  name="key"
                  placeholder="Enter the key"
                  value={formData.key}
                  onChange={handleChange}
                />
              </SoftBox>

              <SoftBox mb={2}>
                <SoftBox mb={1} ml={0.5}>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Order Type
                  </SoftTypography>
                </SoftBox>
                <SoftInput
                  type="text"
                  name="order_type"
                  placeholder="Enter The Order Type"
                  value={formData.order_type}
                  onChange={handleChange}
                />
              </SoftBox>

                            <SoftBox mb={2} sx={{ display: "flex", alignItems: "center" }}>
                <input
                  type="checkbox"
                  name="is_visible"
                  id="is_visible"
                  checked={formData.is_visible}
                  onChange={handleChange}
                  style={{
                    marginRight: "5px",
                    padding: "10px",
                    borderRadius: "5px",
                    border: "1px solid #ccc",
                  }}
                  F
                />
                <SoftTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                  htmlFor="is_visible"
                >
                  Is Visible
                </SoftTypography>
              </SoftBox>
              <SoftBox mb={2}>
                <SoftBox mb={1} ml={0.5}>
                  <SoftTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Photo
                  </SoftTypography>
                </SoftBox>
                {formData.icon && (
                  <img
                    src={
                      typeof formData.icon !== "string"
                        ? URL.createObjectURL(formData.icon)
                        : formData.icon
                    }
                    alt="Service"
                    style={{
                      width: "150px",
                      height: "150px",
                      borderRadius: "5px",
                    }}
                  />
                )}
                <input
                  type="file"
                  name="icon"
                  onChange={handleThumbnailChange}
                  style={{ width: "100%", padding:'10px', border:'1px solid #ccc', borderRadius:'5px'  }}
                />
              </SoftBox>
            </>
          )}

          {/* Submit Button */}
          <SoftBox mt={4} mb={1}>
            <SoftButton
              variant="gradient"
              color="info"
              fullWidth
              onClick={handleSubmit}
            >
              Submit
            </SoftButton>
          </SoftBox>
        </SoftBox>
      </SoftBox>
    </SoftBox>
  );
};

export default EditOtherService;
